import type { RouteRecordRaw } from 'vue-router';

const menuIconPaths = new Set([
  'brandManag',
  'storeManag',
  'brandMaterial',
  'feeCenter',
  'bizManag',
  'productManage',
  'orderManage',
  'operateSettlement',
  'headSettings',
  'deduction',
  'deviceManage',
  'deviceRecord',
  'operationTools',
  'memberCenter',
  'memberConfig',
  'memberAsset',
  'operateRecord',
  'decorate',
  'template',
  'agreement',
  'advert',
  'channelManage',
]);

/** 在路由路径拼接、子级展开前，为已登记菜单补齐本地图标。 */
export function applyMenuIconFallbacks(routes: RouteRecordRaw[]): void {
  routes.forEach((route) => {
    const path = route.path.replace(/^\/|\/$/g, '');
    if ((!route.meta?.icon || route.meta.icon === '#') && menuIconPaths.has(path)) {
      route.meta = { ...route.meta, icon: path };
    }
    if (route.children) {
      applyMenuIconFallbacks(route.children);
    }
  });
}
